import React from 'react';
import ReactQuill from 'react-quill-new';
import styled from '@emotion/styled';
import 'react-quill-new/dist/quill.snow.css';

const EDITOR_MODULES = {
  toolbar: [
    ['bold', 'italic'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image'],
    ['clean'],
  ],
};

const EDITOR_FORMATS = [
  'bold',
  'italic',
  'list',
  'link',
  'image',
];

const EditorWrapper = styled.div`
  .ql-toolbar.ql-snow {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }

  .ql-container.ql-snow {
    min-height: 280px;
    border-bottom-left-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
    font-size: 1rem;
  }

  .ql-editor {
    min-height: 280px;
  }
`;

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

const QuillRichTextInput: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
}) => (
  <EditorWrapper>
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      modules={EDITOR_MODULES}
      formats={EDITOR_FORMATS}
      placeholder={placeholder}
    />
  </EditorWrapper>
);

export default QuillRichTextInput;
